import type { PLTableEntry, UserProfile } from './types'
import { teamAbbr, teamId } from './teams'

const MOCK_FAVOURITE_TEAM = teamId('Man Utd')

export const mockProfile: UserProfile = {
  name: 'Respect Woodinho',
  initials: 'RW',
  favouriteTeam: MOCK_FAVOURITE_TEAM,
  // Derived from the registry rather than hand-typed — this used to read 'MUFC',
  // which matched no shield file and no other abbreviation in the app.
  favouriteTeamAbbr: teamAbbr(MOCK_FAVOURITE_TEAM),
}

// Pre-season fallback only (all clubs level on 0 points, alphabetical) — used before any gameweek
// has been simulated. Once results exist, PLPage is fed a table derived from the simulated season
// instead; this is not the ongoing source of truth for standings.
export const mockPLTable: PLTableEntry[] = [
  'Arsenal',
  'Aston Villa',
  'Bournemouth',
  'Brentford',
  'Brighton',
  'Chelsea',
  'Coventry City',
  'Crystal Palace',
  'Everton',
  'Fulham',
  'Hull City',
  'Ipswich Town',
  'Leeds',
  'Liverpool',
  'Manchester City',
  'Man Utd',
  'Newcastle',
  'Nottingham Forest',
  'Sunderland',
  'Tottenham',
].map((name, index) => ({
  position: index + 1,
  team: teamId(name),
  points: 0,
  played: 0,
  won: 0,
  drawn: 0,
  lost: 0,
  goalsFor: 0,
  goalsAgainst: 0,
  goalDifference: 0,
}))
